import { MoonIcon, SunIcon } from '@heroicons/react/outline'

import {
  HARD_MODE_ALERT_MESSAGE,
  HARD_MODE_DESCRIPTION,
  HIGH_CONTRAST_MODE_DESCRIPTION,
} from '../../constants/strings'
import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: (active: boolean) => void
  isDarkMode: boolean
  handleDarkMode: (active: boolean) => void
  isHighContrastMode: boolean
  handleHighContrastMode: (active: boolean) => void
  isKeyboardSwapped: boolean
  handleSwapKeyboard: (active: boolean) => void
  hasGameStarted: boolean
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
  isKeyboardSwapped,
  handleSwapKeyboard,
  hasGameStarted,
}: Props) => {
  return (
    <BaseModal title="Iestatījumi" isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-2 flex flex-col divide-y divide-solid divide-slate-200 dark:divide-slate-600">
        <SettingsToggle
          settingName="Tēma"
          flag={isDarkMode}
          handleFlag={handleDarkMode}
          isHighContrast={isHighContrastMode}
          toggleSlot={
            isDarkMode ? (
              <MoonIcon className="h-5 w-5 stroke-slate-800" />
            ) : (
              <SunIcon className="h-5 w-5 stroke-slate-800" />
            )
          }
        />
        <SettingsToggle
          settingName="Augsta kontrasta režīms"
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
          isHighContrast={isHighContrastMode}
          description={HIGH_CONTRAST_MODE_DESCRIPTION}
        />
        <SettingsToggle
          settingName="Grūtais režīms"
          flag={isHardMode}
          handleFlag={handleHardMode}
          isHighContrast={isHighContrastMode}
          disabled={hasGameStarted && !isHardMode}
          description={
            hasGameStarted && !isHardMode
              ? HARD_MODE_ALERT_MESSAGE
              : HARD_MODE_DESCRIPTION
          }
        />
        <SettingsToggle
          settingName="Samainīt taustiņus"
          flag={isKeyboardSwapped}
          handleFlag={handleSwapKeyboard}
          isHighContrast={isHighContrastMode}
          description='Apmainīt vietām "Ievadīt" un "Dzēst" taustiņus'
        />
      </div>
    </BaseModal>
  )
}
